export default __webpack_public_path__ + "static/media/03-mojo.2153e454.svg";